<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
        <AppHeader class="pb-0 mb-0" />
      </v-flex>
      <v-flex xs12 sm11 md10 align-self-center style="min-height:90vh !important;">
        <v-layout wrap pa-6 pa-md-12 style="color: #000">
          <v-flex xs12 align-self-center pa-2 class="poppinsregular mb-4">
            <h1 class="poppinsbold" style="font-size: 28px; color: #1e293b;">
              Privacy Policy
            </h1>
            <v-divider class="mt-3 mb-6"></v-divider>
          </v-flex>

          <v-flex xs12 v-if="appLoading" class="text-center py-12">
            <v-progress-circular indeterminate color="primary" size="64" width="5"></v-progress-circular>
          </v-flex>

          <v-flex text-left xs12 align-self-center pa-2 v-else-if="text">
            <div id="pageContent" v-html="text"></div>
          </v-flex>

          <v-flex text-left xs12 align-self-center pa-2 v-else>
            <span style="letter-spacing: 0.91px">
              Privacy policy content is currently not available.
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AppHeader from "@/components/Common/appHeaderP";
import axios from "axios";

export default {
  name: "PublicPrivacyPolicy",
  components: {
    AppHeader,
  },
  data() {
    return {
      appLoading: false,
      text: null,
      msg: null,
      showSnackBar: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/content/get/privacy_policy"
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data && response.data.status && response.data.data) {
            const rawData = response.data.data;
            if (rawData.content && typeof rawData.content === "object") {
              this.text = rawData.content.content || "";
            } else {
              this.text = rawData.content || "";
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.error("Failed to load Privacy Policy:", err);
        });
    }
  }
};
</script>

<style>
#pageContent {
  font-family: 'Poppins', 'Inter', sans-serif;
  line-height: 1.7;
  color: #334155;
}
#pageContent p img {
  max-width: 80vw;
  max-height: 200vh;
}
#pageContent h1, #pageContent h2, #pageContent h3 {
  margin-top: 1.2rem;
  margin-bottom: 0.6rem;
  color: #0f172a;
}
#pageContent ul, #pageContent ol {
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}
</style>

